export default function livePhoneFormat() {
  const inputs = $('.live-phone-format');
  inputs.on('keyup', function () {
    const split = ([3, 6, 10]).sort((a, b) => a - b); // places where there should be space
    const val = $(this).val().replace(/\s+/g, '');
    const output = val.toString().split('');
    for (let i = 0; i < split.length; i += 1) {
      if (split[i] < val.length) {
        output.splice(split[i] + i, 0, ' ');
      } else {
        break;
      }
    }
    $(this).val(output.slice(0,15).join(''));
  });

  if(inputs.val()) {
    inputs.trigger('keyup');
  }
}
